<template>
  <v-card :disabled="loading" :loading="loading">
    <v-card-title>
      <h2>{{ $t("officer_config.config_curriculum") }}</h2>
    </v-card-title>
    <v-card-text>
      <v-tabs v-model="level_tab">
        <v-tabs-slider color="yellow"></v-tabs-slider>
        <v-tab v-for="(level, i) in levels" :key="i">
          <h3>{{ objectTranslator(level, "LEVEL_NAME") }}</h3>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="level_tab" touchless>
        <v-tab-item v-for="(level, i) in levels" :key="i">
          <v-card flat>
            <v-card-text>
              <v-autocomplete
                v-model="year_id[level.LEVEL_ID]"
                v-bind:label="$t('officer_config.academic_year')"
                v-bind:items="
                  listFilter(config_years, level.LEVEL_ID, 'LEVEL_ID')
                "
                v-bind:item-value="(item) => item.YEAR_ID"
                v-bind:item-text="(item) => item.SEMESTER + ' / ' + item.YEAR"
                outlined
                @change="(year_id) => select_year(level.LEVEL_ID, year_id)"
              ></v-autocomplete>

              <div v-show="year_id && year_id[level.LEVEL_ID]">
                <v-divider></v-divider>
                <v-btn
                  color="success"
                  @click="
                    $refs.addEditDialog.open_add_modal({
                      rounds: rounds[level.LEVEL_ID],
                      projects: projects[level.LEVEL_ID],
                      level_id: level.LEVEL_ID,
                      year_id: year_id[level.LEVEL_ID],
                    })
                  "
                  class="mb-5 mt-4"
                >
                  <v-icon>mdi-plus</v-icon>{{ $t("officer_config.addnew") }}
                </v-btn>

                <v-autocomplete
                  v-model="round_id[level.LEVEL_ID]"
                  v-bind:label="$t('officer_config.round_number_name')"
                  v-bind:items="rounds_for_show(rounds[level.LEVEL_ID])"
                  v-bind:item-value="(item) => item.ROUND_ID"
                  v-bind:item-text="
                    (item) =>
                      item.ROUND_NUMBER + ' - ' + objectTranslator(item, 'NAME')
                  "
                  outlined
                  @change="
                    (round_id) =>
                      select_round(
                        level.LEVEL_ID,
                        year_id[level.LEVEL_ID],
                        round_id
                      )
                  "
                ></v-autocomplete>

                <v-autocomplete
                  v-model="project_id[level.LEVEL_ID]"
                  v-bind:label="$t('officer_config.project_name')"
                  v-bind:items="projects_for_show(projects, level.LEVEL_ID)"
                  v-bind:item-value="(item) => item.PROJECT_ID"
                  v-bind:item-text="
                    (item) => objectTranslator(item, 'PROJECT_NAME')
                  "
                  outlined
                  @change="
                    (project_id) => select_project(level.LEVEL_ID, project_id)
                  "
                ></v-autocomplete>

                <div v-show="project_id && project_id[level.LEVEL_ID]">
                  <v-divider class="mb-5"></v-divider>
                  <v-simple-table min-height="300px" class="mt-3">
                    <thead>
                      <tr>
                        <th
                          class="text-center blue-grey darken-1 white--text font-weight-light"
                        >
                          {{ $t("officer_config.edit") }}
                        </th>
                        <th
                          class="text-center blue-grey darken-1 white--text font-weight-light"
                        >
                          {{ $t("officer_config.delete") }}
                        </th>
                        <th
                          class="text-center blue-grey darken-1 white--text font-weight-light"
                        >
                          #
                        </th>
                        <!-- <th
                            class="text-center blue-grey darken-1 white--text font-weight-light"
                          >
                            {{ $t("officer_config.round_number_name") }}
                          </th>
                          <th
                            class="text-center blue-grey darken-1 white--text font-weight-light"
                          >
                            {{ $t("officer_config.project_name") }}
                          </th> -->
                        <th
                          class="text-center blue-grey darken-1 white--text font-weight-light"
                        >
                          {{ $t("officer_config.faculty") }}
                        </th>
                        <th
                          class="text-center blue-grey darken-1 white--text font-weight-light"
                        >
                          {{ $t("officer_config.curriculum_name") }}
                        </th>
                        <th
                          class="text-center blue-grey darken-1 white--text font-weight-light"
                        >
                          {{ $t("officer_config.branch_if_any") }}
                        </th>
                        <!-- <th
                            class="text-center blue-grey darken-1 white--text font-weight-light"
                          >
                            {{ $t("officer_config.tuition_fee") }}
                          </th> -->
                        <th
                          v-if="level.LEVEL_ID === '1'"
                          class="text-center blue-grey darken-1 white--text font-weight-light"
                        >
                          {{ $t("officer_config.tcas_program_id") }}
                        </th>
                        <th
                          v-if="
                            level.LEVEL_ID === '2' || level.LEVEL_ID === '3'
                          "
                          class="text-center blue-grey darken-1 white--text font-weight-light"
                        >
                          {{ $t("officer_config.admit_type") }}
                        </th>
                        <th
                          v-if="
                            level.LEVEL_ID === '2' || level.LEVEL_ID === '3'
                          "
                          class="text-center blue-grey darken-1 white--text font-weight-light"
                        >
                          {{ $t("officer_config.study_plan") }}
                        </th>
                        <th
                          v-if="
                            level.LEVEL_ID === '2' || level.LEVEL_ID === '3'
                          "
                          class="text-center blue-grey darken-1 white--text font-weight-light"
                        >
                          {{ $t("officer_config.study_classes") }}
                        </th>
                        <th
                          v-if="
                            level.LEVEL_ID === '2' || level.LEVEL_ID === '3'
                          "
                          class="text-center blue-grey darken-1 white--text font-weight-light"
                        >
                          {{ $t("officer_config.specific_nation") }}
                        </th>
                        <th
                          class="text-center blue-grey darken-1 white--text font-weight-light"
                        >
                          {{ $t("officer_config.attach_PDF_if_any") }}
                        </th>
                        <th
                          class="text-center blue-grey darken-1 white--text font-weight-light"
                        >
                          {{ $t("officer_config.attach_URL_if_any") }}
                        </th>
                        <th
                          class="text-center blue-grey darken-1 white--text font-weight-light last-cell"
                        >
                          {{ $t("officer_config.remark_if_any") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="curriculum in listFilter(
                          curriculums[level.LEVEL_ID],
                          project_id[level.LEVEL_ID],
                          'PROJECT_ID'
                        )"
                        :key="curriculum.CURRICULUM_ID"
                      >
                        <td>
                          <v-btn
                            small
                            color="warning"
                            @click="
                              $refs.addEditDialog.open_edit_modal({
                                item: curriculum,
                                rounds: rounds[level.LEVEL_ID],
                                projects: projects[level.LEVEL_ID],
                              })
                            "
                          >
                            <v-icon>mdi-pencil</v-icon
                            >{{ $t("officer_config.edit") }}
                          </v-btn>
                        </td>
                        <td>
                          <v-btn
                            small
                            color="error"
                            @click="open_delete_modal(curriculum)"
                          >
                            <v-icon>mdi-delete</v-icon
                            >{{ $t("officer_config.delete") }}
                          </v-btn>
                        </td>
                        <td>{{ curriculum.CURRICULUM_ID }}</td>
                        <!-- <td>
                            {{
                              curriculum.ROUND_NUMBER +
                                " - " +
                                objectTranslator(curriculum, "ROUND_NAME")
                            }}
                          </td>
                          <td>
                            {{ objectTranslator(curriculum, "PROJECT_NAME") }}
                          </td> -->
                        <td>
                          {{ objectTranslator(curriculum, "FACULTY_NAME") }}
                        </td>
                        <td>
                          <div class="deep-orange--text">
                            {{ curriculum.CURRICULUM_SHORT_NAME_TH }}
                          </div>
                          <div class="brown--text">
                            {{ curriculum.CURRICULUM_SHORT_NAME_EN }} [{{
                              curriculum.CURRICULUM_YEAR
                            }}]
                          </div>
                        </td>
                        <td>
                          {{ objectTranslator(curriculum, "BRANCH_NAME") }}
                        </td>
                        <!-- <td>{{ curriculum.CURRICULUM_FEE }}</td> -->
                        <td v-if="level.LEVEL_ID === '1'">
                          {{ curriculum.TCAS_PROGRAM_ID }}
                        </td>
                        <td
                          v-if="
                            level.LEVEL_ID === '2' || level.LEVEL_ID === '3'
                          "
                        >
                          {{
                            objectTranslator(
                              curriculum,
                              "STUDY_ADMIT_TYPE_NAME"
                            )
                          }}
                        </td>
                        <td
                          v-if="
                            level.LEVEL_ID === '2' || level.LEVEL_ID === '3'
                          "
                        >
                          {{ objectTranslator(curriculum, "STUDY_PLAN_NAME") }}
                        </td>
                        <td
                          v-if="
                            level.LEVEL_ID === '2' || level.LEVEL_ID === '3'
                          "
                        >
                          {{
                            objectTranslator(curriculum, "STUDY_CLASSES_NAME")
                          }}
                        </td>
                        <td
                          v-if="
                            level.LEVEL_ID === '2' || level.LEVEL_ID === '3'
                          "
                        >
                          {{
                            objectTranslator(curriculum, "SPECIFIC_NATION_NAME")
                          }}
                        </td>
                        <td class="text-center nowrap">
                          <div v-if="curriculum.PDF_EXISTS === '1'">
                            <a
                              target="blank"
                              :href="file_path + curriculum.CURRICULUM_ID"
                              >Download</a
                            >
                            <v-btn
                              x-small
                              outlined
                              color="red"
                              class="ml-2"
                              @click="open_delete_file_modal(curriculum)"
                            >
                              {{ $t("officer_config.delete") }}
                            </v-btn>
                          </div>
                        </td>
                        <td class="break-all">{{ curriculum.URL }}</td>
                        <td class="last-cell">{{ curriculum.REMARK }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>

    <ConfigCurriculumAddEditDialog
      ref="addEditDialog"
      :toggle_loading="toggle_loading"
      :fetch_data="fetch_data"
    />

    <ConfigDeleteDialog
      v-model="showing_delete_modal"
      :title="$t('officer_config.config_curriculum')"
      :text="
        to_delete_curriculum_item
          ? ' ' +
            objectTranslator(to_delete_curriculum_item, 'CURRICULUM_SHORT_NAME')
          : ''
      "
      :deleteFunction="delete_config_curriculum"
    />

    <ConfigDeleteDialog
      v-model="showing_delete_file_modal"
      :title="$t('officer_config.delete_file')"
      :text="
        to_delete_curriculum_file_item
          ? ' PDF ' +
            objectTranslator(
              to_delete_curriculum_file_item,
              'CURRICULUM_SHORT_NAME'
            )
          : ''
      "
      :deleteFunction="delete_config_curriculum_file"
    />
  </v-card>
</template>

<script>
import { createHelpers } from "vuex-map-fields";
import ConfigCurriculumAddEditDialog from "@/components/config/ConfigCurriculumAddEditDialog";
import ConfigDeleteDialog from "@/components/config/ConfigDeleteDialog";
import {
  objectTranslator,
  dateFromDBTranslator as dt,
} from "@/helper/translator";
import { listFilter, getById } from "@/helper/filter";
import ConfigProvider from "@/services/config.provider";

const configService = new ConfigProvider();
const { mapFields: mapOfficerConfigFields } = createHelpers({
  getterType: "officerConfig/getField",
  mutationType: "officerConfig/updateField",
});

export default {
  name: "ConfigCurriculum",
  data: function() {
    return {
      loading: false,
      level_tab: null,
      showing_delete_modal: false,
      showing_delete_file_modal: false,
      to_delete_CURRICULUM_id: null,
      to_delete_level_id: null,
      to_delete_year_id: null,
      to_delete_curriculum_id: null,
      to_delete_curriculum_item: null,
      to_delete_curriculum_file_item: null,

      //--- selected data in each level panel
      rounds: {}, // each for level id
      projects: {}, // each for level id
      curriculums: {}, // each for level id
      year_id: {}, // each for level id
      round_id: {}, // each for level id
      project_id: {}, // each for level id
    };
  },
  components: {
    ConfigCurriculumAddEditDialog,
    ConfigDeleteDialog,
  },
  computed: {
    file_path() {
      return (
        process.env.VUE_APP_ENDPOINT +
        "admission/api/" +
        "?function=get-document-file&service_type=config-curriculum&" +
        "response_type=file&CURRICULUM_ID="
      );
    },
    levels() {
      return this.$store.state.ref.levels;
    },
    ...mapOfficerConfigFields({
      config_years: "config_years",
    }),
  },
  methods: {
    dt,
    getById,
    listFilter,
    objectTranslator,
    toggle_loading(status) {
      this.loading = status;
    },

    rounds_for_show(rounds_in_level) {
      if (rounds_in_level) {
        return [
          ...rounds_in_level,
          {
            NAME_EN: "All",
            NAME_TH: "ทั้งหมด",
            ROUND_ID: "all",
            ROUND_NUMBER: "",
          },
        ];
      } else return [];
    },

    projects_for_show(projects, level_id) {
      if (projects[level_id]) {
        if (this.round_id[level_id] !== "all") {
          return projects[level_id].filter(
            (item) => item.ROUND_ID === this.round_id[level_id]
          );
        }
        return [
          ...projects[level_id],
          {
            PROJECT_NAME_EN: "All",
            PROJECT_NAME_TH: "ทั้งหมด",
            PROJECT_ID: "all",
          },
        ];
      } else return [];
    },

    async fetch_ref_data(level_id, year_id) {
      // non editable data of this page
      this.loading = true;
      const rounds = await configService.getFilteredRounds({ year_id });
      this.$set(this.rounds, level_id, rounds);
      const projects = await configService.getFilteredProjects({ year_id });
      this.$set(this.projects, level_id, projects);
      this.loading = false;
    },

    async fetch_data(level_id, year_id) {
      // editable data of this page
      this.loading = true;
      const curriculums = await configService.getFilteredCurriculums({
        year_id,
      });
      this.$set(this.curriculums, level_id, curriculums);
      this.loading = false;
    },

    async select_year(level_id, year_id) {
      this.round_id[level_id] = null;
      this.project_id[level_id] = null;
      await this.fetch_ref_data(level_id, year_id);
    },

    async select_round(level_id, year_id, round_id) {
      this.project_id[level_id] = null;
      this.round_id[level_id] = round_id;
      await this.fetch_ref_data(level_id, year_id);
    },

    async select_project(level_id, project_id) {
      this.project_id[level_id] = project_id;
      await this.fetch_data(level_id, this.year_id[level_id]);
    },

    open_delete_modal(item) {
      this.to_delete_level_id = item.LEVEL_ID;
      this.to_delete_year_id = item.YEAR_ID;
      this.to_delete_CURRICULUM_id = item.CURRICULUM_ID;
      this.to_delete_curriculum_item = item;
      this.showing_delete_modal = true;
    },
    async delete_config_curriculum() {
      this.loading = true;

      let response = await configService
        .deleteCurriculum({
          id: this.to_delete_CURRICULUM_id,
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });

      this.fetch_data(this.to_delete_level_id, this.to_delete_year_id);

      if (response && response.status)
        this.$toasted.success(this.$t("toasted.delete_successfully"));
      else this.$toasted.error(this.$t("toasted.cannot_delete"));

      this.showing_delete_modal = false;
      this.loading = false;
    },

    open_delete_file_modal(item) {
      this.to_delete_curriculum_file_item = item;
      this.showing_delete_file_modal = true;
    },
    async delete_config_curriculum_file() {
      this.loading = true;

      let response = await configService
        .deleteCurriculumFile({
          id: this.to_delete_curriculum_file_item.CURRICULUM_ID,
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });

      this.fetch_data(
        this.to_delete_curriculum_file_item.LEVEL_ID,
        this.to_delete_curriculum_file_item.YEAR_ID
      );

      if (response && response.status)
        this.$toasted.success(this.$t("toasted.delete_successfully"));
      else this.$toasted.error(this.$t("toasted.cannot_delete"));

      this.showing_delete_file_modal = false;
      this.loading = false;
    },
  },
  created: function() {
    this.$store.dispatch("ref/getLevels");
    this.$store.dispatch("officerConfig/getYears");
  },
};
</script>

<style scoped>
th {
  padding: 0;
  overflow: hidden;
  /* white-space: nowrap; */
  border-width: 1px;
  border-right-width: 0;
  border-style: solid;
  border-color: rgb(211, 211, 211);
}
td {
  /* overflow: hidden;
  white-space: nowrap; */
  border-width: 1px;
  padding: 0;
  border-right-width: 0;
  border-style: solid;
  border-color: rgb(211, 211, 211);
}
.nowrap {
  white-space: nowrap;
}
.break-all {
  word-break: break-all;
}
.last-cell {
  border-right-width: 1px;
}
</style>
